import { createContext } from 'react';

export const MinimalCodeContext = createContext({
  minimalCode: true,
});
